import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './fonts/Nexa-Heavy.ttf'
import './fonts/Nexa-ExtraLight.ttf'
import './fonts/nexa-regular.ttf'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from './helpers/ScrollToTop';

// Pré-rendu (react-snap) : si le HTML arrive déjà rempli, on hydrate au lieu
// de re-render — les crawlers (Google, IA) voient le contenu sans JavaScript.
const rootElement = document.getElementById('root');
const app = (
  <Router>
    <React.StrictMode>
      <ScrollToTop />
      <App />
    </React.StrictMode>
  </Router>
);
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
